<template>
  <div class="pwd-box">
    <div class="form-box">
      <el-form
        ref="shareForm"
        :model="shareForm"
        label-width="100px"
        class="demo-dynamic">
        <el-form-item
          :rules="pwdRule"
          prop="pwd"
          label="访问密码"
        >
          <div class="input-box">
            <el-input
              v-model="shareForm.pwd"
              maxlength="6"
              type="password"
              placeholder="请输入密码"
            />
            <span
              v-if="shareForm.pwd && shareForm.pwd.length>0"
              class="sp-max">{{ shareForm.pwd.length }}/6</span>
          </div>
          <span class="sp-word" />
        </el-form-item>
      </el-form>
      <div
        class="btn-box">
        <el-button @click="onClickCancel">取 消</el-button>
        <span class="sp-space" />
        <el-button
          type="primary"
          @click="submitForm('shareForm')">登 录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { $form, $http, $token, axiosRequest } from "../../utils";
import * as CourseListServer from "../../api/courseList";

export default {
  name: "SharePassword",
  data() {
    return {
      // 表单字段
      shareForm: {
        pwd: "",
      },
      // 密码规则
      pwdRule: [
        { required: true, message: "请输入访问密码", trigger: "blur" },
        { validator: this.isNum, trigger: "blur" },
      ],
    };
  },
  computed: {
    code() {
      // 如果参数code存在表示需要登录密码
      const { code } = this.$route.query;
      return code;
    },
    theme_id() {
      const { theme_id } = this.$route.query;
      return theme_id;
    },
    id() {
      const { id } = this.$route.query;
      return id;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      // 监听回车 查询
      document.onkeydown = function (event) {
        const e = event || window.event;
        if (e && e.keyCode === 13) { // 回车键的键值为13
          e.preventDefault();
          self.submitForm("shareForm");
        }
      };
    },
    // 判断是否为数字
    isNum(rule, value, callback) {
      const reg = /^[0-9]*$/;
      if (!reg.test(value)) {
        callback(new Error("只能为数字"));
      } else {
        callback();
      }
    },
    // 取消
    onClickCancel() {
        this.shareForm.pwd = "";
    },
    // 提交表单
    submitForm(formName) {
      const self = this;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submit({
            open_pwd: self.shareForm.pwd,
            open_key: self.code,
          });
        }
      });
    },

    submit(obj) {
      CourseListServer.checkSharePwd("/course_middle/check_share_pwd", obj)
              .then((res) => {
                console.log("请求结果==>", res);
                res && this.submitSucceed(res);
              })
              .catch(this.submitFailure);
    },

    submitSucceed(token) {
      console.log(`submitSucceed:---${token.toString()}`);
      const baseHeaders = {
        Authorization: `Bearer ${token.data}`,
      };

      $http.init({ baseHeaders });

      $token.set(token.data);
      this.$router.push(`/course_preview/${this.id}/${this.theme_id}?code=${this.code}`);
    },

    submitFailure(error) {
        try {
          Message.error(error.response.data.message);
        } catch (e) {
          Message.error("验证失败");
        }
    },
  },
};
</script>

<style lang="postcss" scoped>
.demo-dynamic >>> .el-form-item__label{
  color: white;
}
.pwd-box{
    background-color: black;
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-image: url("/login-bg.png");
}
.form-box{
    width: 375px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: column nowrap;
    padding: 42px 38px 38px 38px;
    background-color: rgba(0, 0, 0, .6);
    border-radius: var(--bd-radius);
    color: white;
    margin: 0px 20px;
}
.sp-word{
    width: 60px;
    text-align: left;
    margin-left: 10px;
}
.sp-space{
    display: inline-block;
    width: 30px;
    height: 20px;
}
.btn-box{
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.input-box{
    width: 100%;
    position: relative;
}
.sp-max{
    position: absolute;
    right: 10px;
    color: #ccc;
}
</style>
